import { Component, OnInit, HostListener, ViewChild, ElementRef, OnDestroy, Injectable } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { PageType } from 'src/app/services/pageTypes';
import { SearchData } from 'src/app/services/searchData';
import { WorkExperience } from 'src/app/services/userModel';
import { WidgetModule } from 'src/app/widget/widget.module';
import { ProfileBannerComponent } from '../profile-banner/profile-banner.component';
import { PersonalProfileEditComponent } from '../../personal-profile-edit/personal-profile-edit.component';
import { CurrentOrganizationProviderService } from '../../../services/current-organization-provider.service';





@Component({
  selector: 'app-personal-profile',
  standalone: true,
  imports: [
    CommonModule,
    WidgetModule,
    ProfileBannerComponent,
    PersonalProfileEditComponent
  ],
  templateUrl: './personal-profile.component.html',
  styleUrls: ['./personal-profile.component.scss'],
})
export class PersonalProfileComponent implements OnInit, OnDestroy {
  profileBannerCurrentOrganization: WorkExperience;
  profile: boolean = false;
  showWidget: boolean = false;
  eventEmitter: Subscription;
  pageName: any;
  flag = true
  constructor(private route: ActivatedRoute,
    private router: Router,
    public searchData:SearchData,
    private pageType: PageType) {
    this.eventEmitter = this.pageType.getPageName().subscribe(res => {
      this.pageName = res.pages
    })

    if (this.route.queryParams['_value'].userId !== localStorage.getItem('userId')) {
      this.showWidget = false
    } else {
      this.showWidget = true
    }
  }

  ngOnInit() {

    this.searchData.setHighlighter('');
    if (this.route.snapshot.url[0].path == 'personalProfile' || this.pageName === 'personalProfile') {
      this.profile = true;
      if (this.route.queryParams['_value'].menu == 'billing') {
        this.profile = false;
      }
    }

    if (this.route.queryParams['_value'].menu == 'billing') {
      this.pageName = 'billing';
      this.profile = false;
      var data: any = {};
      data.pages = "billing"
      this.pageType.setPageName(data)

    }

    // Handle returnUrl parameter for proper back button navigation
    this.route.queryParams.subscribe(params => {
      if (params.returnUrl) {
        // Store the returnUrl for later use if needed
        // The browser's back button should naturally handle the navigation
        console.log('Return URL detected:', params.returnUrl);
      }
    });

  }

  ngOnDestroy(): void {
    if(this.eventEmitter) {
      this.eventEmitter.unsubscribe();
    }
  }

  elementPosition: any;

  updateProfileBanner(data: WorkExperience) {
    this.profileBannerCurrentOrganization = data;
  }

  @ViewChild('menuScroll') menuElement: ElementRef;
  @ViewChild('suggestionScroll') suggestionElement: ElementRef;
  stopMenuScroll: boolean = false
  stopSuggestionScroll: boolean = false
  @HostListener('window:scroll')
  handleScroll() {
    const YoffSet = window.pageYOffset
    if (YoffSet >= 25) {
      this.stopMenuScroll = true
    } else {
      this.stopMenuScroll = false
    }
  }

}

